import { useAppStore } from '@core/store'
import { useNomesDosModelos } from '@viewer/lib/useNomeDoModelo'

/** "Modelo: MAC · Cha139-…-MAC-AP-0001" no cabeçalho do painel de
 *  propriedades. O nome completo do ficheiro fica no tooltip; o clique
 *  torna esse modelo o activo na lista de modelos. */
export default function ModeloDeOrigem({ modelId }: { modelId: string }) {
  const { nomeDe } = useNomesDosModelos()
  const setActiveModel = useAppStore((s) => s.setActiveModel)
  const activo = useAppStore((s) => s.activeModelId === modelId)
  const nome = nomeDe(modelId)
  if (!nome) return null
  return (
    <button
      type="button"
      onClick={() => setActiveModel(modelId)}
      title={`${nome.completo}${activo ? '' : ' (clique para o tornar o modelo activo na lista de modelos)'}`}
      className="mt-0.5 flex max-w-full items-baseline gap-1 truncate text-left text-[10px] text-[var(--color-text-muted)] hover:text-[var(--color-text)]"
      data-modelo-de-origem={modelId}
    >
      <span>Modelo:</span>
      <span className="truncate font-mono text-[var(--color-text)]">{nome.curto}</span>
    </button>
  )
}
